import _ from 'lodash';
import queryCoursewareAncestry from './queryCoursewareAncestry.gql';

/**
 * Fetch ancestry via apollo for a given elementId (which can be almost anything, but
 * in this case will most likely be a componentId
 * Requires a workspaceId, which is supplied in the cohortSummary payload.
 */
export default async (apolloClient, { workspaceId, elementId }) => {
  const response = await apolloClient.query({
    query: queryCoursewareAncestry,
    variables: {
      workspaceId,
      elementId,
    },
  });

  if (response.error) {
    throw new Error(response.error);
  }

  const { type, ancestry } = _.get(response, 'data.workspace.getCoursewareAncestry');

  return {
    id: elementId,
    type,
    ancestry,
  };
};
